import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Snackbar } from '@material-ui/core';
import { I18n } from 'src/translations/i18n';
import { selectLocale } from 'src/store/selectors/translationSelectors';
import loginPageKeys from 'src/translations/loginPageKeys';
import AppLanguageStorage from 'src/translations/AppLanguageStorage';
function UpdateSnackBar() {
    const hasUpdate = useSelector((state) => state.serviceWorker.hasUpdate);
    const language = useSelector(selectLocale);
    const staticTranslations = loginPageKeys[language] || loginPageKeys[AppLanguageStorage.defaultLanguage];
    const message = I18n.t('UpdateAvailable', { defaultValue: staticTranslations.updateAvailable });
    const buttonText = I18n.t('Reload', { defaultValue: staticTranslations.reload });
    const handleReload = () => {
        window.location.reload();
    };
    return (React.createElement(Snackbar, { anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
        }, open: hasUpdate, message: message, action: [
            React.createElement(Button, { key: "reload", color: "primary", size: "small", onClick: handleReload },
                React.createElement("b", null, buttonText.toUpperCase()))
        ] }));
}
export default UpdateSnackBar;
